import api from '@/helpers/api';

import type {
	AddJobPayload,
	SetNirPayload,
	UpdatePersonalInfoPayload,
} from '@/components/modal/Profile/previewProfile/types';

const updatePersonalInfo = async (
	workerId: string,
	data: UpdatePersonalInfoPayload
): Promise<void> => {
	await api.request<void>({
		url: `/workers/${workerId}/personal-info`,
		method: 'PATCH',
		data,
	});
};

const setNir = async (workerId: string, data: SetNirPayload): Promise<void> => {
	await api.request<void>({
		url: `/workers/${workerId}/nir`,
		method: 'PUT',
		data,
	});
};

const addJob = async (
	workerId: string,
	data: AddJobPayload
): Promise<{ jobEntityId: string }> => {
	const response = await api.request<{ jobEntityId: string }>({
		url: `/workers/${workerId}/jobs`,
		method: 'POST',
		data,
	});
	return response.data;
};

const removeJob = async (workerId: string, jobId: string): Promise<void> => {
	await api.request<void>({
		url: `/workers/${workerId}/jobs/${jobId}`,
		method: 'DELETE',
	});
};

export default {
	updatePersonalInfo,
	setNir,
	addJob,
	removeJob,
};
